import * as PRESSURE_CONSTANT from '../constant/pressureContentConstant';
import * as CONSTANT from '../constant/sequenceContentConstants';

export const findSequenceIndex = (array, idSequence) =>
  array.map((d) => d.Id.toString()).indexOf(idSequence.toString());

export const findMaxValueByRepeatType = (RepeatType) =>
  RepeatType === CONSTANT.RUN_TIME_MODE.TIMES.VALUE ? 5700 : 100;

export const findMaxDigitValueByRepeatType = (RepeatType) =>
  RepeatType === CONSTANT.RUN_TIME_MODE.TIMES.VALUE ? 0 : 2;

export const findIncrementValueByRepeatType = (RepeatType) =>
  RepeatType === CONSTANT.RUN_TIME_MODE.TIMES.VALUE ? 1 : 0.01;

const setDefaultRepeatValue = (sequence) => {
  switch (sequence) {
    case CONSTANT.SEQUENCE_TYPE_ALL_ENUM.PRIME.BE:
      return 7;
    case CONSTANT.SEQUENCE_TYPE_ALL_ENUM.PRIME_BY_SAMPLE.BE:
      return 7;
    case CONSTANT.SEQUENCE_TYPE_ALL_ENUM.CONCENTRATE.BE:
      return 1;
    case CONSTANT.SEQUENCE_TYPE_ALL_ENUM.AIR_RECOVERY.BE:
      return 3;
    case CONSTANT.SEQUENCE_TYPE_ALL_ENUM.DIAFILTRATE.BE:
      return 1;
    case CONSTANT.SEQUENCE_TYPE_ALL_ENUM.BUFFER_RECOVERY.BE:
      return 3;
    // MIXING FEATURE F.A.W
    case CONSTANT.SEQUENCE_TYPE_ALL_ENUM.TUBE_MIXING.BE:
      return 10;
    // MIXING FEATURE F.A.W
    case CONSTANT.SEQUENCE_TYPE_ALL_ENUM.RECIRCULATION.BE:
      return 10;
    default:
      return 7;
  }
};

export const ConvertRepeatMode = (operation) => {
  // const totalTimeEachSequnce = CalcTimeEachSequence(operation);
  // const MINUTE = 60000;
  if (operation.RepeatType === CONSTANT.RUN_TIME_MODE.MINUTES.VALUE) {
    // save minutes to repeat
    // let newRepeatValue = parseFloat(operation.TempRepeat) * parseFloat((MINUTE / totalTimeEachSequnce).toFixed(0));
    const newRepeatValue = operation.TempRepeat;

    operation.TempRepeat = newRepeatValue < 1 ? setDefaultRepeatValue(operation.Sequence) : Math.round(newRepeatValue);
  } else {
    // let newRepeatValue = parseFloat(operation.TempRepeat) / parseFloat((MINUTE / totalTimeEachSequnce).toFixed(0));
    const newRepeatValue = parseFloat(operation.TempRepeat) > 100 ? 100 : parseFloat(operation.TempRepeat);
    operation.TempRepeat = parseFloat(newRepeatValue.toFixed(2));
    if (isInt(operation.TempRepeat)) {
      operation.TempRepeat = Math.round(operation.TempRepeat);
    }
  }

  return operation;
};

export const ConvertRepeatModeFromBE = (operation) => {
  const totalTimeEachSequnce = CalcTimeEachSequence(operation);
  const MINUTE = 60000;
  if (operation.RepeatType === CONSTANT.RUN_TIME_MODE.MINUTES.VALUE) {
    // save minutes to repeat
    const newRepeatValue = parseFloat(operation.TempRepeat) * parseFloat((MINUTE / totalTimeEachSequnce).toFixed(0));
    operation.TempRepeat = Math.round(newRepeatValue);
  } else {
    const newRepeatValue = parseFloat(operation.TempRepeat) / parseFloat((MINUTE / totalTimeEachSequnce).toFixed(0));
    operation.TempRepeat = parseFloat(newRepeatValue.toFixed(2));
    if (isInt(operation.TempRepeat)) {
      operation.TempRepeat = Math.round(operation.TempRepeat);
    }
  }

  return operation;
};

// TODO: this method could be simplified
export const CalcTimeEachSequence = (operation) => {
  let DiaphragmTimingOpen = 0;
  let DiaphragmTimingClose = 0;
  let valveTiming = 0;
  if (operation.PressureState.PressureType === PRESSURE_CONSTANT.PRESSURE_TYPE.LO) {
    DiaphragmTimingOpen = operation.SequenceParams.Lo.DiaphragmTimingOpen;
    DiaphragmTimingClose = operation.SequenceParams.Lo.DiaphragmTimingClose;
    valveTiming = operation.SequenceParams.Lo.ValveTiming;
  } else {
    DiaphragmTimingOpen = operation.SequenceParams.Hi.DiaphragmTimingOpen;
    DiaphragmTimingClose = operation.SequenceParams.Hi.DiaphragmTimingClose;
    valveTiming = operation.SequenceParams.Hi.ValveTiming;
  }
  const totalTimeEachSequnce = Number(DiaphragmTimingOpen) + Number(DiaphragmTimingClose) + Number(valveTiming);
  return totalTimeEachSequnce;
};

function isInt(n) {
  return n % 1 === 0;
}
